import { useEffect, useId, useRef, useState } from 'react';

function readCollapsed(storageKey) {
  try {
    const stored = localStorage.getItem(storageKey);
    if (stored === 'true') return true;
    if (stored === 'false') return false;
  } catch {
    /* ignore */
  }
  return false;
}

export default function SidebarCollapsibleGroup({
  groupId,
  title,
  hasActiveItem = false,
  children,
  storageKeyPrefix = 'mmj-sidebar',
}) {
  const contentId = useId();
  const storageKey = `${storageKeyPrefix}:${groupId}`;
  const [collapsed, setCollapsed] = useState(() => {
    // Start open if this group owns the current route; still allow manual collapse after.
    if (hasActiveItem) return false;
    return readCollapsed(storageKey);
  });
  const wasActiveRef = useRef(hasActiveItem);

  // Only auto-expand when navigating *into* this group — not when the user
  // collapses while an item inside is already active.
  useEffect(() => {
    const becameActive = hasActiveItem && !wasActiveRef.current;
    wasActiveRef.current = hasActiveItem;
    if (!becameActive) return;
    setCollapsed(false);
    try {
      localStorage.setItem(storageKey, 'false');
    } catch {
      /* ignore */
    }
  }, [hasActiveItem, storageKey]);

  const toggle = () => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(storageKey, String(next));
      } catch {
        /* ignore */
      }
      return next;
    });
  };

  return (
    <div className={`sidebar-nav-group${collapsed ? ' is-collapsed' : ''}`}>
      <button
        type="button"
        className="sidebar-nav-group-toggle"
        aria-expanded={!collapsed}
        aria-controls={contentId}
        onClick={toggle}
      >
        <span className="sidebar-nav-group-title">{title}</span>
        <svg
          className="sidebar-nav-group-chevron"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          aria-hidden
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
      <div id={contentId} className="sidebar-nav-group-items" hidden={collapsed}>
        {children}
      </div>
    </div>
  );
}
